var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29628 9.60891L11.1665 6.73158C11.1889 6.70917 11.2066 6.68257 11.2186 6.65331C11.2307 6.62405 11.2369 6.5927 11.2369 6.56104C11.2368 6.52939 11.2306 6.49805 11.2184 6.46882C11.2063 6.43959 11.1885 6.41304 11.1661 6.39069C11.1436 6.36834 11.117 6.35062 11.0878 6.33854C11.0585 6.32647 11.0272 6.32027 10.9955 6.32031C10.9639 6.32035 10.9325 6.32663 10.9033 6.33878C10.8741 6.35093 10.8475 6.36872 10.8252 6.39114L8.12561 9.0978L5.42605 6.39114C5.38091 6.34587 5.31963 6.3204 5.2557 6.32031C5.19177 6.32023 5.13043 6.34555 5.08517 6.39069C5.0399 6.43584 5.01443 6.49711 5.01434 6.56104C5.01426 6.62497 5.03958 6.68632 5.08472 6.73158L7.95494 9.60891C7.97732 9.63138 8.00392 9.64921 8.03321 9.66137C8.0625 9.67354 8.0939 9.6798 8.12561 9.6798C8.15732 9.6798 8.18872 9.67354 8.21801 9.66137C8.2473 9.64921 8.2739 9.63138 8.29628 9.60891Z",
    fill: "#424942",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown2);
export default __webpack_public_path__ + "static/media/chevron-down-2.870ddf28.svg";
export { ForwardRef as ReactComponent };